import createWangsVuePlugin, { WangsVueOptions } from 'lib/plugins/WangsVue';

import defaultProps from './defaultProps';
import locale from './locale';
import { useToastConfig } from '../utils/salesToast.util';

const config: WangsVueOptions = {
  locale,
  defaultProps,
  useToastConfig,
};

export default createWangsVuePlugin(config);
